import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function RequestsIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_3583)">
        <path
          d="M77.0997 64.5317H2.9003C1.20846 64.5317 0 63.3233 0 61.6314V2.9003C0 1.20846 1.20846 0 2.9003 0H77.0997C78.7915 0 80 1.20846 80 2.9003V61.6314C80 63.3233 78.5499 64.5317 77.0997 64.5317Z"
          fill="#EAEEF9"
        />
        <path
          d="M67.1902 52.6888C67.1902 67.6737 55.1056 80 39.8791 80C24.6525 80 12.8096 67.6737 12.8096 52.6888C12.8096 37.7039 24.8942 25.3776 40.1208 25.3776C55.3473 25.3776 67.1902 37.7039 67.1902 52.6888Z"
          fill="#00416B"
        />
        <path
          d="M63.565 52.6888C63.565 65.7402 52.9305 76.3746 39.8792 76.3746C26.8278 76.3746 16.1934 65.7402 16.1934 52.6888C16.1934 39.6375 26.8278 29.003 39.8792 29.003C52.9305 29.003 63.565 39.6375 63.565 52.6888Z"
          fill="#EAEEF9"
        />
        <path
          d="M46.405 37.2205L36.2539 50.997L43.5047 54.3807L47.8551 37.9456C48.0968 36.9788 47.13 36.4955 46.405 37.2205Z"
          fill="#00C4B3"
        />
        <path
          d="M74.9241 12.3263H5.07515C4.35008 12.3263 3.625 11.6012 3.625 10.8761V5.07553C3.625 4.35046 4.35008 3.62538 5.07515 3.62538H74.9241C75.6492 3.62538 76.3743 4.35046 76.3743 5.07553V10.8761C76.3743 11.6012 75.6492 12.3263 74.9241 12.3263Z"
          fill="#00416B"
        />
        <path
          d="M9.42569 7.97583C9.42569 8.70091 8.70062 9.42598 7.97554 9.42598C7.25047 9.42598 6.52539 8.70091 6.52539 7.97583C6.52539 7.25076 7.25047 6.52568 7.97554 6.52568C8.70062 6.52568 9.42569 7.25076 9.42569 7.97583Z"
          fill="#FBFCFE"
        />
        <path
          d="M15.2265 7.97583C15.2265 8.70091 14.5014 9.42598 13.7763 9.42598C13.0512 9.42598 12.3262 8.70091 12.3262 7.97583C12.3262 7.25076 13.0512 6.52568 13.7763 6.52568C14.5014 6.52568 15.2265 7.25076 15.2265 7.97583Z"
          fill="#FBFCFE"
        />
        <path
          d="M21.0273 7.97583C21.0273 8.70091 20.3022 9.42598 19.5771 9.42598C18.852 9.42598 18.127 8.70091 18.127 7.97583C18.127 7.25076 18.852 6.52568 19.5771 6.52568C20.3022 6.52568 21.0273 7.25076 21.0273 7.97583Z"
          fill="#FBFCFE"
        />
        <path
          d="M27.795 47.3716L37.7043 54.6224L40.1212 49.5468L28.2783 46.4048C27.795 46.1631 27.3116 47.1299 27.795 47.3716Z"
          fill="#00C4B3"
        />
        <path
          d="M44.9548 52.6888C44.9548 55.5891 42.7795 57.7644 39.8792 57.7644C36.9789 57.7644 34.8037 55.5891 34.8037 52.6888C34.8037 49.7885 36.9789 47.6133 39.8792 47.6133C42.7795 47.6133 44.9548 49.7885 44.9548 52.6888Z"
          fill="#FBFCFE"
        />
        <path
          d="M42.5379 52.6888C42.5379 54.139 41.3295 55.3474 39.8793 55.3474C38.4292 55.3474 37.2207 54.139 37.2207 52.6888C37.2207 51.2387 38.4292 50.0302 39.8793 50.0302C41.3295 50.0302 42.5379 51.2387 42.5379 52.6888Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_3583">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
